import { StyleSheet } from 'aphrodite';

import { THEME } from '../../../components-v2/Theme/theme';

const {
	spacing,
	colors,
	common: { border, borderRadius },
	typography: { fontSizes },
} = THEME;

export const styleSheet = StyleSheet.create({
	linkButton: {
		paddingTop: spacing.sm,
	},
	addContactButtons: {
		whiteSpace: 'nowrap',
	},
	clearSearchButton: {
		height: 40,
		whiteSpace: 'nowrap',
		marginRight: spacing.md,
	},
	addContactsControls: {
		gap: '1rem',
		justifyContent: 'flex-end',
	},
	container: {
		gap: '1rem',
		height: '100%',
	},
	drawerContainer: {
		backgroundColor: colors.background.light,
		height: '100%',
		padding: spacing.lg,
		width: '100%',
		gap: spacing.md,
	},
	divider: {
		borderBottom: border,
	},
	loader: {
		marginTop: 60,
	},
	searchControls: {
		gap: '1rem',
	},
	searchDescription: {
		alignItems: 'center',
		background: colors.background.light,
		border,
		borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: 14,
		justifyContent: 'space-between',
		padding: `8px ${spacing.md}px`,
	},
	searchRow: {
		justifyContent: 'space-between',
	},
	legend: {
		margin: spacing.none,
		width: '100%',
	},
	statusFilters: {
		margin: '10px 0 5px 0',
	},
	fieldset: {
		border: 'none',
		padding: 0,
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	collapseTrigger: {
		color: colors.text.dark,
		fontSize: fontSizes.lg,
		width: '100%',
		justifyContent: 'space-between',
		paddingRight: spacing.xs,
	},
	paddingBottomSm: {
		paddingBottom: spacing.sm,
	},
	paddingBottomMd: {
		paddingBottom: spacing.md,
	},
	closed: {
		transform: 'rotate(90deg)',
	},
	open: {
		transform: 'rotate(-90deg)',
	},
	hide: {
		display: 'none',
	},
});
